export interface SwitchChangeEventDetail {
    checked: boolean;
}

export type SwitchLabelAlignment = 'top' | 'center' | 'bottom';

